(function () {
	'use strict';

	/**
	 * @ngdoc component
	 * @name mx.shell:mxShellNavItem
	 * @module mx.shell
	 * @requires $rootScope
	 * @requires $scope
	 * @requires $document
	 * @requires {@ref mx.shell.SidebarService mx.shell.SidebarService}
	 * @requires {@ref mx.shell.EventService mx.shell.EventService}
	 * @description
	 * Sidebar control
	 * @usage <mx-shell-sidebar layout="column"></mx-shell-sidebar>
	 */

	angular.module('mx.shell').component('mxShellSidebar', {
		controller: MxShellSidebarCtrl,
		controllerAs: 'vm',
		templateUrl: 'components/mx-shell-sidebar/mx-shell-sidebar.html',
	});

	MxShellSidebarCtrl.$inject = ['$rootScope', '$scope', '$document', '$element', 'mx.shell.SidebarService', 'mx.shell.EventService'];

	function MxShellSidebarCtrl($rootScope, $scope, $document, $element, sidebarService, eventService) {
		var vm = this;

		vm.$onInit = function () {
			vm.sidebarService = sidebarService;
			vm.additionalButtonClick = additionalButtonClick;
			vm.hintKey = '⇑+r';
		};

		vm._debouncedLayoutChangeDispatcher = $.debounce(500, function () {
			eventService.dispatchEvent(mx.shell.EventCodes.LayoutChanged);
		});

		$rootScope.$on('$locationChangeSuccess', function () {
			vm.sidebarService.close();
		});

		function additionalButtonClick(name) {
			vm.sidebarService.show();
			eventService.dispatchEvent(mx.shell.EventCodes.SidenavAdditionalButtonClick, { name: name });
		}
	}
})();
